import {isNullOrUndefined} from "../../../services/Validator";

export default function LevelAInfoButton({displayButton, onClick}) {
    // Used in LevelAMetaData to display info button when
    // LevelA has description

    // BUILD
    if (displayButton === false || isNullOrUndefined(onClick))
        return null
    return (
        <div className={"mt-[3px] cursor-pointer flex justify-center items-center rounded-full w-[15px] min-w-[15px] h-[15px] min-h-[15px] bg-greyLight5 hover:bg-greyLight7"}
             onClick={onClick}>
            <span className={`text-[12px] text-black font-normal pr-[0px]`}>
                {"i"}
            </span>
        </div>
    );
}